import { FC } from "react";
import "./ModalPaymentView.scss";
import { Card, Col, Row } from "react-bootstrap";
import ModalDefault from "../../../ModalDefault/ModalDefault";
import moment from "moment";
import FormatMoney from "../../../../utils/FormatMoney";
import RenderMethodIcon from "../../../../utils/RenderMethodIcon";

interface ModalPaymentViewProps {
  show: boolean;
  onClose: () => void;
  payment: any;
}

const ModalPaymentView: FC<ModalPaymentViewProps> = ({
  show,
  onClose,
  payment,
}) => {
  const p = payment;
  // Prefer pre-resolved values passed from the listing
  const methodName: string = p?.methodName
    || p?.plans_payments_methods?.name
    || p?.method?.name
    || "";
  const statusName: string = p?.statusName
    || p?.plans_payments_status?.name
    || p?.status?.name
    || "";
  const subscription = p?.subscription || null;
  const user = subscription?.user || null;
  const plan = subscription?.plan || null;
  const cycle = subscription?.cycle || null;


  const renderStatusBadge = (name: string) => {
    const n = name?.toLowerCase();
    const cls = n === "pago" ? "bg-success" : n === "pendente" ? "bg-warning" : "bg-danger";
    return <span className={`badge ${cls}`}>{name || "-"}</span>;
  };

  return (
    <ModalDefault
      title="Detalhes do Pagamento"
      show={show}
      onClose={onClose}
      sizeModal="lg"
      showFooter={false}
      scrollable
    >
      {p && (
        <div className="ModalPaymentView">
          <Row>
            <Col md={12}>
              {/* Pagamento */}
              <Card className="mb-3 shadow-sm">
                <Card.Header className="pb-0 d-flex align-items-center justify-content-between">
                  <h6 className="text-uppercase text-muted fw-bold mb-0">
                    <i className="fas fa-credit-card me-2"></i>Pagamento
                  </h6>
                  <span className="text-sm text-muted">#{p?.id || "-"}</span>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <p className="text-sm mb-1">
                        <strong>Data do Pagamento:</strong>{" "}
                        {p?.payment_date
                          ? moment(p.payment_date).format("DD/MM/YYYY HH:mm")
                          : "-"}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="text-sm mb-1">
                        <strong>Valor:</strong>{" "}
                        <b>{p?.amount_paid != null ? FormatMoney(p.amount_paid) : "-"}</b>
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="text-sm mb-1">
                        <strong>Método:</strong>{" "}
                        {methodName ? RenderMethodIcon(methodName, 18) : "-"}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="text-sm mb-0">
                        <strong>Status:</strong>{" "}
                        {statusName ? renderStatusBadge(statusName) : "-"}
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Assinatura vinculada */}
              {subscription && (
                <Card className="mb-0 shadow-sm">
                  <Card.Header className="pb-0 d-flex align-items-center justify-content-between">
                    <h6 className="text-uppercase text-muted fw-bold mb-0">
                      <i className="fas fa-file-signature me-2"></i>Assinatura Vinculada
                    </h6>
                    <span className="text-sm text-muted">#{subscription?.id || "-"}</span>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <p className="text-sm mb-1">
                          <strong>Plano:</strong> {plan?.name || "-"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="text-sm mb-1">
                          <strong>Usuário:</strong>{" "}
                          {user
                            ? `${user.partner_code ? user.partner_code + " - " : ""}${user.name || "-"}`
                            : "-"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="text-sm mb-1">
                          <strong>E-mail:</strong> {user?.email || "-"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="text-sm mb-1">
                          <strong>Tipo:</strong>{" "}
                          {cycle ? (cycle === "annual" ? "Anual" : "Mensal") : "-"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="text-sm mb-0">
                          <strong>Período:</strong>{" "}
                          {subscription?.start_date
                            ? moment(subscription.start_date).format("DD/MM/YYYY")
                            : "-"}{" "}
                          à{" "}
                          {subscription?.end_date
                            ? moment(subscription.end_date).format("DD/MM/YYYY")
                            : "-"}
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </div>
      )}
    </ModalDefault>
  );
};

export default ModalPaymentView;